import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'availableBranch',
})
export class AvailableBranchPipe implements PipeTransform {
  constructor(private trSv: TranslateService) {}

  transform(value: any[], availableBranchs: any[]): any[] {
    const msg = this.trSv.instant('DISPONIBLE');
    if (availableBranchs.length) {
      value.forEach((data) => {
        const branch = availableBranchs.find(
          (x) => x.branchContactId === data.id
        );
        if (branch && branch.existence !== 0) {
          data.msg = msg;
        } else {
          data.msg = 'No Disponible';
        }
      });
    }
    return value;
  }
}
